import React from "react";
 
const CheckBox = props => {
    function handleClick(e){
        if(props.onChange) props.onChange({target:{name:props.name, value:e.target.checked}})
    }
    // return <input {...props} checked={props.defaultChecked} onClick={handleClick} onChange={null} />
    return <React.Fragment>
        <input {...props}  id={props.name} onClick={handleClick} onChange={null} />
        {/* {props.label && <label for={props.name}> {props.label}</label> } */}
    </React.Fragment> 
    // return <input {...props} defaultChecked={props.defaultChecked} onClick={handleClick} onChange={null} />

};

CheckBox.propTypes = {
    
};

CheckBox.defaultProps = {
    // inputclassName:"",
    // label:"asdf",
     name:"cb",
    type:"checkbox"
};

export default CheckBox;
